export const mockSupportUserStatus = {
  ativo: false,
};
